<div class="mx-auto max-w-2xl mt-8">
    <div class="flex">
        <nav class="w-80">
            <ul>
                <li>
                    <a routerLink="/admin/dashboard" [title]="'admin.dashboard' | translate" routerLinkActive="active" translate>admin.dashboard</a>
                </li>
                <li>
                    <a routerLink="/admin/check-config" [title]="'admin.config' | translate" routerLinkActive="active" translate>admin.config</a>
                </li>
            </ul>
        </nav>
    
        <main class="ml-4">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>